export default __webpack_public_path__ + "static/datelabel-dropdown-dont-1-dark-05ac0b86285cd33c7092b93d35dbbdc8.png";